import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Loader, Video } from '@/components'

@observer
export default class CoursePageWatch extends Component {
  componentDidMount() {
    const {
      courseContentfulId,
      section,
      sectionContentfulId,
      unitContentfulId,
    } = this.props
    const { isLoadingVideo: isLoadingSectionVideo, video: sectionVideo } =
      section
    if (!sectionVideo && !isLoadingSectionVideo) {
      section.loadVideo(
        courseContentfulId,
        unitContentfulId,
        sectionContentfulId,
      )
    }
  }
  renderContent() {
    const { section } = this.props
    const { isLoadingVideo: isLoadingSectionVideo, video: sectionVideo } =
      section
    const {
      entryCaptionsUrl: videoEntryCaptionsUrl,
      entryId: videoEntryId,
      entryPath: videoEntryPath,
      entrypoint: videoEntrypoint,
      entryThumbnailUrl: videoEntryThumbnailUrl,
      entryUrl: videoEntryUrl,
      type: videoType,
      url: videoURL,
    } = sectionVideo || {}
    if (!sectionVideo || isLoadingSectionVideo) return <Loader />
    return (
      <Video
        entryCaptionsUrl={videoEntryCaptionsUrl}
        entryId={videoEntryId}
        entryPath={videoEntryPath}
        entrypoint={videoEntrypoint}
        entryThumbnailUrl={videoEntryThumbnailUrl}
        entryUrl={videoEntryUrl}
        type={videoType}
        url={videoURL}
      />
    )
  }
  render() {
    const { section } = this.props
    const { hasVideo: hasVideoSection } = section || {}
    if (!hasVideoSection) return <div>No video</div>
    return <div className="CoursePageWatch">{this.renderContent()}</div>
  }
}
